"use client";

import { getDataAutomationGroup } from "@/helpers";
import { ChangeEvent, FC, useState, KeyboardEvent } from "react";

interface IpAddressInputProps {
  setLastValidIpAddress: (value: string) => void;
  setIpAddressError: (value: string | null) => void;
}

export const IpAddressInput: FC<IpAddressInputProps> = ({
  setLastValidIpAddress,
  setIpAddressError,
}) => {
  const [ipAddressInput, setIpAddressInput] = useState<string>("192.168.1.1");

  const handleIpAddressInput = () => {
    const correctIpAddressPattern =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    if (correctIpAddressPattern.test(ipAddressInput)) {
      setIpAddressError(null);
      setLastValidIpAddress(ipAddressInput);
    } else {
      setIpAddressError("Enter valid IP address");
    }
  };

  return (
    <div className="flex flex-col">
      <label
        className="text-body-xs text-swdc-gray-400 pb-2 font-bold"
        htmlFor="ip-address"
      >
        IP Address (IPv4)
      </label>
      <input
        className="border-swdc-gray-200 text-swdc-gray-400 focus:outline-swdc-black-600 rounded-button h-10 w-full border-2 bg-white pr-2 pl-4 md:w-48"
        type="text"
        id="ip-address"
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setIpAddressInput(e.target.value)
        }
        onBlur={handleIpAddressInput}
        onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") handleIpAddressInput();
        }}
        value={ipAddressInput}
        autoComplete="off"
        {...getDataAutomationGroup("input-field")}
      />
    </div>
  );
};
